import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import { Navigate } from "react-router-dom";
import { Container } from "@material-ui/core";
import { Button } from "../components/ui/forms/Button";
import Header from "../components/layout/Header/Header";
import Footer from "../components/layout/Footer";
import Pane from "../components/layout/Pane/Pane";
import Tabs from "../components/layout/Pane/Tabs";
import Spinner from "../components/ui/Spinner";
import { Typography } from "@material-ui/core";

import { UserContext } from "../contexts/UserContext";
import { PaneContext } from "../contexts/PaneContext";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PersonIcon from "@material-ui/icons/Person";
import { SubHeading } from "../components/ui/SubHeading";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import CardOrderReports from "../components/Reports/CardOrderReports";

const Reports = () => {
  const [loading, setLoading] = useState(false);
  const { changeTab } = useContext(PaneContext);
  const { id, Site, updateSite } = useContext(UserContext);

  const handleSave = async () => {
    setLoading(true);
    await updateSite(Site.siteCode, Site);
    setLoading(false);
  };

  useEffect(() => {
    //changeTab(0);
    //eslint-disable-next-line
  }, []);

  return id ? (
    <PageContainer>
      <Header />
      <Container>
        <ReportsPane
          variant="reports"
          subHeader={
            <Typography style={Tstyles}>
              <AssessmentOutlinedIcon style={iconStyles1} />
              Reports
            </Typography>
          }
        >
          <Tabs
            data={[
              {
                index: 0,
                title: (
                  <Typography style={Tstyles}>
                    {" "}
                    <CreditCardIcon style={iconStyles} /> Cards
                  </Typography>
                ),
                //icon: CreditCardIcon,
                component: <CardOrderReports />,
              },
            ]}
          />
        </ReportsPane>
        <Footer />
      </Container>
    </PageContainer>
  ) : (
    <Navigate to="/login" />
  );
};

const iconStyles = {
  fontSize: "18px",
};

const iconStyles1 = {
  fontSize: "16px",
};

const Tstyles = {
  fontWeight: "Bold",
  fontSize: "16px",
};

const PageContainer = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ReportsPane = styled(Pane)`
  margin-top: 4rem;
`;

const Actions = styled.div`
  padding: 2rem;
`;

export default Reports;
